<template>
  <div>
    <form-filtered-select
      :selected-key="selectedProvider ? selectedProvider.value : null"
      :options="activeProviderOptions"
      :invalid="invalid"
      placeholder="Provider"
      @updateDropdownValue="onUpdateValue"
      @close="$emit('close')" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedProvider: null
    }
  },
  computed: {
    ...mapGetters('provider', ['activeProviderOptions'])
  },
  watch: {
    value: function () {
      if (this.selectedProvider && this.value.value !== this.selectedProvider.value) {
        this.selectedProvider = this.value
      }
    }
  },
  mounted () {
    this.selectedProvider = this.value
    this.$watch('selectedProvider', function () {
      this.$emit('input', this.selectedProvider)
    })
  },
  methods: {
    onUpdateValue (value) {
      this.selectedProvider = value
    }
  }
}
</script>

<style lang="scss">
.multiselect {
  &__content-wrapper {
    z-index: 3000 !important;
  }
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
